export const randomId = () => `carbon-${Math.random().toString(36).slice(2, 11)}`;
